import type { DalError, DalReturn } from "@/core/dal/data.type";
import { dalDbOperation } from "@/core/dal/helper";
import type { SubscriberFormData } from "@/core/schemas/subscriber.form.schema";
import type ApiService from "@/core/services/api.service";
import type APIEndpointsService from "@/core/services/api-endpoints.service";

class SubscribersService {
  constructor(
    private apiService: ApiService,
    private apiEndpointsService: APIEndpointsService
  ) {}

  submitSubscriber(data: SubscriberFormData): Promise<DalReturn<void, DalError>> {
    return dalDbOperation(async () => {
      await this.apiService.put(
        this.apiEndpointsService.getRoutes().subscribers.put(),
        data
      );
    });
  }
}

export default SubscribersService;
